<template>
  <v-tabs color="primary" slider-color="blue-darken-3">
    <v-tab :to="{ name: 'document-agreement-single-preview' }" replace>
      Огляд
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-requisites' }" replace>
      Реквізити
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-versions' }" replace>
      Версії
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-comments' }" replace>
      Коментарі
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-logs' }" replace>
      Історія
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-routes' }" replace>
      Маршрут
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-related' }" replace>
      Пов'язані документи
    </v-tab>
    <v-tab :to="{ name: 'document-agreement-single-extra' }" replace>
      Додаткові документи
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
defineOptions({
  name: 'DocumentAgreementTabs',
})
</script>
